import { gql } from 'graphql-request';
import type { ResponseStatus, OrderItemDiscounts } from '@types';

interface CartDiscounts {
  orderItemDiscounts: OrderItemDiscounts[];
  couponTotalDiscount: number;
}

export interface GetCartDiscountsResponse {
  wGetCartDiscounts: {
    status: ResponseStatus;
    discounts: CartDiscounts;
  }
}

export const GET_CART_DISCOUNTS_QUERY = gql`
  query wGetCartDiscounts($uid: UUID) {
    wGetCartDiscounts(uid: $uid)
  }
`;
